import React from 'react';
import { MediaErrorType } from "../../../../view-model";
import clsx from 'clsx';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';

// TODO i18n

const CameraErrorType = props => {
  const {
    icons,
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "media-camera-error p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, icons.map((icon, i) => /*#__PURE__*/React.createElement("i", {
    key: i,
    className: clsx('mdi font-size-38 text-primary', {
      'me-3': i != icons.length - 1
    }, icon)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, children))));
};
export const CameraError = props => {
  const {
    error,
    retry,
    audio
  } = props;
  switch (error.name) {
    case MediaErrorType.NOT_SUPPORTED_USER_MEDIA:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: ['mdi-cast-off']
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "The browser being used does not have the necessary technology to access the video / audio input devices of the system (WebRTC)");
    case MediaErrorType.NOT_CONSTRAINT_SATISFIED:
    case MediaErrorType.OVERCONSTRAINED:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: audio ? ['mdi-flask-empty-remove-outline', 'mdi-camera-plus', 'mdi-microphone-plus'] : ['mdi-flask-empty-remove-outline', 'mdi-camera-plus']
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "The required media input devices are not compatible with the current devices, certain hardware features or enhancements are not available. ", error.message && /*#__PURE__*/React.createElement(React.Fragment, null, "(", error.message, ")"));
    case MediaErrorType.NOT_FOUND_DEVICES:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: audio ? ['mdi-magnify', 'mdi-camera-off', 'mdi-microphone-off'] : ['mdi-magnify', 'mdi-camera-off']
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "The required media input devices are not accessible by the system itself or could not be detected."), /*#__PURE__*/React.createElement("div", null, "Please, connect the following media input devices:"), /*#__PURE__*/React.createElement("div", {
        className: "d-flex align-items-center mt-3 justify-content-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-camera me-2 text-secondary"
      }), /*#__PURE__*/React.createElement("div", null, "Camera")), audio && /*#__PURE__*/React.createElement("div", {
        className: "d-flex align-items-center mt-3 justify-content-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-microphone me-2 text-secondary"
      }), /*#__PURE__*/React.createElement("div", null, "Microphone")), /*#__PURE__*/React.createElement(RippleButton, {
        className: "btn btn-primary mt-4",
        onClick: () => retry()
      }, "Retry")));
    case MediaErrorType.ABORT_ERROR:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: audio ? ['mdi-camera-off', 'mdi-microphone-off'] : ['mdi-camera-off']
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "The system has not allowed access to the required media input devices or they are already in use."), /*#__PURE__*/React.createElement(RippleButton, {
        className: "btn btn-primary mt-3",
        onClick: () => retry()
      }, "Retry")));
    case MediaErrorType.SECURITY_ERROR:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: audio ? ['mdi-shield-lock-outline', 'mdi-camera-off', 'mdi-microphone-off'] : ['mdi-shield-lock-outline', 'mdi-camera-off']
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "Security restrictions do not allow access to required media input devices (HTTPS)");
    case MediaErrorType.PERMISSION_DENIED:
    case MediaErrorType.NOT_ALLOWED:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: audio ? ['mdi-shield-key-outline', 'mdi-camera-off', 'mdi-microphone-off'] : ['mdi-shield-key-outline', 'mdi-camera-off']
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "The necessary permissions have not been granted to allow access to the required media input devices."), /*#__PURE__*/React.createElement("div", null, "Please, access the browser settings and grant the necessary permissions to continue."), /*#__PURE__*/React.createElement(RippleButton, {
        className: "btn btn-primary mt-3",
        onClick: () => retry()
      }, "Retry")));
    default:
      return /*#__PURE__*/React.createElement(CameraErrorType, {
        icons: ['mdi-alert']
      }, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-alert-outline me-2 text-danger"
      }), "An unknown error occurred while trying to access the required media input devices");
  }
};